import * as React from 'react';
import { StyledInformationalPage } from '../../../common/static.styles';
import { HeadTitle } from '../../../components/head-title/HeadTitle';
import { TranslatedPath } from '../../../components/navigation/language-switcher/LanguageSwitcher.props';
import { DefaultLayout } from '../../../layout/default/DefaultLayout';

/* tslint:disable:max-line-length */
const seo = {
  description:
    'Warner Bros. Entertainment, est leader mondial en divertissement et les secteur liés sur tous les médias et plateformes actuels et émergents.',
};
/* tslint:enable:max-line-length */

const translatedPaths: TranslatedPath[] = [{ locale: 'nl-BE', path: '/over' }];

const title = 'Organisation';

// noinspection JSUnusedGlobalSymbols
export default () => (
  <DefaultLayout locale='fr-BE' seo={seo} translatedPaths={translatedPaths}>
    <HeadTitle title={title} />
    <StyledInformationalPage>
      <div className='content'>
        <h1>{title}</h1>
        <div>
          <p>
            <strong>Warner Bros. Entertainment</strong>, est leader mondial en divertissement et les secteur liés sur
            tous les médias et plateformes actuels et émergents. Filiale de la Time Warner Company, le Studio est
            précurseur dans chaque aspect de l'industrie de l'entertainment du long-métrage, la vidéo, à la production
            télévisuel et distributeur mondial de DVD et Blu-Ray, distribution digitale, jeux vidéos, animation,
            merchandising, et diffusion TV. DC Entertainment, la société qui a inventé les Super Héros les plus
            iconiques, comme Batman, Superman, Wonder Woman, The Flash et pleins d'autres, fait également partie de
            Warner Bros.
          </p>
          <p>
            Le 4 avril 1923, les Studios Warner Bros. ont été fondé par les 4 frères Warner : Albert, Sam, Harry et Jack
            L.. En 1927 la sortie du premier film audio-synchronisé "Le Chanteur de Jazz" a lancé la tendance innovative
            et influante qui est devenue synonyme de Warner Bros.
          </p>
          <p>
            Depuis ses débuts les studios Warner Bros. ont rassemblé un héritage impressionnant, grâce à la création
            d'une entreprise de distribution très diversifiée. La cohérence et le succès de longue date de la boîte
            ressortent d'un management stable à travers son histoire, de fortes relations créatives avec des stars et
            producteurs mondialement connus, et un dévouement inébranlable à l'excellence.
          </p>
          <p>
            Aujourd'hui la bibliothèque de Warner Bros. est l'une des plus prestigieuses et précieuses du monde. Elle
            compte plus de 79 000 heures de programmation, dont près de 7 500 films et 4 500 programmes télé composés de
            milliers d'épisodes. Le Studio gère également l'une des collections les plus fortes en marques et franchises
            au monde.
          </p>
        </div>
      </div>
    </StyledInformationalPage>
  </DefaultLayout>
);
